import React from 'react';
import { CloudinaryImageType } from '@appTypes/CloudinaryImageType';
import BlockImage from '../BlockImage/BlockImage';

export interface ImageSerializerProps {
  value: { image: CloudinaryImageType; captionMode?: 'text-right' | 'text-left' };
}

export const Image = ({ value: { image } }: ImageSerializerProps) => <BlockImage image={image} />;
